module.exports = __webpack_public_path__ + "static/media/WU_STEPS_recipient_active.f3213ea6.svg";